import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    minHeight: '80px',
  },
});

export default useStyles;
